import { getNode } from "../../lib/list";

function getOptions(group, slugs) {
	const { orphans = [], groups = [] } = group;
	const options = [];

	options.push(...orphans.filter(o => slugs.includes(o.slug)));
	groups.forEach(g => {
		options.push(...getOptions(g, slugs))
	});

	return options;
}

function getOptionGroups(groups, slugs) {
	const results = [];

	groups.forEach(g => {
		if (slugs.includes(g.slug)) results.push(g);
		if (g.groups) {
			results.push(...getOptionGroups(g.groups, slugs));
		}
	});

	return results;
}

function getTag(groups, slug, parentSlug) {
	for (const g of groups) {
		if (parentSlug) {
			const tag = g.tags?.find(t => t.slug === parentSlug)?.tags?.find(k => k.slug === slug);
			if (tag) return tag;
		} else {
			const tag = g.tags?.find(t => t.slug === slug);
			if (tag) return tag;
		}
	}
	return null;
}

function hasTags(entry, tags) {
	entry.tagGroups?.forEach(g => {
		g.tags?.forEach(t => {
			tags = tags.filter(s => s !== t.slug);
		});
	});

	return tags.length <= 0;
}

function setGroupEnabled(group, enabled) {
	const { orphans = [] } = group;
	group.active = enabled;
	orphans.forEach(o => o.active = enabled);
}

function operate(target, params, listEntry) {
	const { operation, value } = params;

	if (operation === "add") {
		if (target.toString().startsWith("+")) {
			return "+" + (parseInt(target.slice(1)) + value);
		} else {
			return target + value;
		}
	} else if (operation === "add-per-unit") {
		return target + value * listEntry.size;
	}
}

function appendTag(node, group, tag) {
	const existingGroup = node.tagGroups.find(g => g.slug === group.slug);
	if (existingGroup) {
		const existingTag = existingGroup.tags.find(t => t.slug === tag.slug);
		if (!existingTag) existingGroup.tags.push(tag);
	} else {
		node.tagGroups = [
			{
				name: group.name,
				slug: group.slug,
				tags: [tag]
			}
		]
	}
}

const TLAOK_EFFECTS = {
	"MODIFY_SIZE": (node, params, source) => {
		if ([
			"flogobollon",
			"skorpios",
			"oni-ayakashi",
			"kami-ayakashi",
			"tengu-bushi",
			"tengu-ayakashi",
			"kappa-bushi",
			"origami-warriors",
			"oni-ayakashi-leader",
			"kami-ayakashi-leader",
			"tengu-bushi-leader",
			"tengu-ayakashi-leader",
			"kappa-bushi-leader",
			"origami-warriors-leader"
		].includes(source.slug)) {
			node.listEntry.size += source.size;
		} else {
			node.listEntry.size = operate(node.listEntry.size, params);
		}
	},
	"ENABLE_OPTIONS": (node, params) => {
		const { slugs, enabled } = params;
		if (node.listEntry.options) {
			const options = getOptions(node.listEntry.options, slugs);
			options.forEach(o => o.active = enabled);
		}
	},
	"ENABLE_CONQUEST_FOR_WARLORD": (node, params) => {
		const { listEntry } = node;
		if (listEntry.isWarlord) {
			const options = getOptions(listEntry.options, "conquest");
			options.forEach(o => o.active = true);
		}
	},
	"DWEGHOM_HERALDS": (node, params, source, list) => {
		const armyRules = list.tagGroups?.find(g => g.slug === "army-rules");
		const tags = [];

		if (armyRules?.tags?.find(t => t.slug === "the-tempered-creed") || list.selections.includes("the-tempered-creed")) {
			tags.push({name: "Tempered", slug: "tempered"});
		}

		if (armyRules?.tags?.find(t => t.slug === "the-ardent-creed") || list.selections.includes("the-ardent-creed")) {
			tags.push({name: "Ardent", slug: "ardent"});
		}

		if (tags.length > 0) {
			const existingGroup = node.listEntry?.tagGroups?.find(g => g.slug === "battlefield-role");
			if (!existingGroup) {
				node.listEntry.tagGroups.push({
					name: "Battlefield Role",
					slug: "battlefield-role",
					tags: [...tags]
				});
			} else {
				const existingSlugs = existingGroup.tags.map(t => t.slug);
				existingGroup.tags.push(...tags.filter(t => !existingSlugs.includes(t.slug)));
			}
		}
	},
	"CULTS_OF_UKUNFAZANE": (node, params, source, list) => {
		const { listEntry } = node;
		const { tagGroups = [] } = listEntry;

		let slug = null;
		let name = null;
		let entries = [];

		if (node.entrySlug === "scion-of-conquest") {
			slug = "cult-of-conquest";
			name = "Cult of Conquest";
		} else if (getTag(tagGroups, "war")) {
			slug = "cult-of-war";
			name = "Cult of War";
			entries.push(
				{
					"name": "Chosen of War",
					"slug": "chosen-of-war"
				},
			);
		} else if (getTag(tagGroups, "death")) {
			slug = "cult-of-death";
			name = "Cult of Death";
			entries.push(
				{
					"name": "Chosen of Death",
					"slug": "chosen-of-death"
				},
			);
		} else if (getTag(tagGroups, "famine")) {
			slug = "cult-of-famine";
			name = "Cult of Famine";
			entries.push(
				{
					"name": "Chosen of Famine",
					"slug": "chosen-of-famine"
				},
			);
		} else if (getTag(tagGroups, "conquest")) {
			slug = "cult-of-conquest";
			name = "Cult of Conquest";
			entries.push(
				{
					"name": "Chosen of Conquest",
					"slug": "chosen-of-conquest"
				},
			);
		}

		if (slug) {
			const nodes = [];

			if (node.entrySlug !== "scion-of-conquest") {
				nodes.push(node);

				const { listEntry } = node;
				listEntry.warband.restricted = listEntry.warband.restricted.filter(e => !entries.some(s => e.slug === s.slug));
				listEntry.warband.restricted.push(...entries);

				const entrySlugs = entries.map(e => e.slug);
				const attached = node.parent.children.filter(c => entrySlugs.includes(c.entrySlug))
				attached.forEach(a => a.type = "restricted");
			}

			const links = Object.keys(node.linkedNodes || {});
			links.forEach(l => {
				const linkedNode = getNode(list, node.linkedNodes[l][0])
				if (linkedNode) nodes.push(linkedNode);
			});

			nodes.forEach(n => {
				const { tagGroups = [] } = n.listEntry;
				const existingGroup = tagGroups.find(g => g.slug === "battlefield-role");
				if (!existingGroup) {
					n.listEntry.tagGroups.push({
						name: "Battlefield Role",
						slug: "battlefield-role",
						tags: [
							{
								name,
								slug
							}
						]
					});
				} else {
					existingGroup.tags.push({
						name,
						slug
					});
				}
			});
		}
	},
	"ELEMENTAL_CONFLUENCE": (node, params) => {
		const { listEntry } = node;
		if (listEntry.isWarlord) {
			const g = listEntry.options.groups.find(g => g.slug === "courts");
			g.maxOptions = 2;
		}
	},
	"ENABLE_OPTION_GROUPS": (node, params) => {
		const { slugs, enabled } = params;
		const { listEntry } = node;
		if (listEntry.options.groups) {
			const groups = getOptionGroups(listEntry.options.groups, slugs);
			groups.forEach(g => setGroupEnabled(g, enabled));
		}
	},
	"MODIFY_OPTION_GROUP": (node, params) => {
		const { groups = [] } = node.listEntry.options;
		const { slug, minOptions, maxOptions } = params;

		const group = groups.find(g => g.slug === slug)
		if (group) {
			if (minOptions) {
				group.minOptions = operate(group.minOptions, minOptions);
			}
			if (maxOptions) {
				group.maxOptions = operate(group.maxOptions, maxOptions);
			}
		}
	},
	"MODIFY_OPTION_COST": (node, params) => {
		const { groupSlugs = [], optionSlugs = [], action } = params;
		const { listEntry } = node;

		function modify(option) {
			if (action === "DOUBLE") option.cost *= 2;
		}

		if (groupSlugs.length) {
			listEntry.options.groups.filter(g => groupSlugs.includes(g.slug)).forEach(g => {
				const { orphans = [] } = g;
				orphans.forEach(o => modify(o));
			})
		} else if (optionSlugs.length) {
			listEntry.options.orphans.filter(o => optionSlugs.includes(o.slug)).forEach(o => o.cost = operate(o.cost, params, listEntry));
		}
	},
	"ADD_TAGS": (node, params, source, list) => {
		const { listEntry } = node;
		const { tagGroup, tags = [], profileName, parentSlug } = params;

		if (!tagGroup || tags.length <= 0) return;

		// findGroup
		// if not, create it and push tags
		// if exists, look for tags

		if (!listEntry.profiles && profileName) return;

		let profileIndex = null;
		if (listEntry.profiles) {
			if (profileName) {
				profileIndex = listEntry.profiles.findIndex(p => p.profileName === profileName);
				if (profileIndex < 0) {
					return;
				}
			} else {
				profileIndex = 0;
			}
		}

		const tagGroups = listEntry?.tagGroups || listEntry?.profiles?.[profileIndex]?.tagGroups || node.tagGroups;

		const group = tagGroups?.find(g => g.slug === tagGroup.slug);
		if (parentSlug) {
			if (!group) return;
			tags.forEach(t => {
				const existingTag = group.tags.find(e => e.slug === parentSlug)?.tags?.find(j => j.slug === t.slug);
				if (existingTag && existingTag.variable && t.variable) {
					existingTag.variable = Math.max(existingTag.variable, t.variable);
				} else if (!existingTag) {
					if (t.slug === "wizard" && group.tags.find(e => e.slug === "priest")) return;
					const parent = group.tags.find(e => e.slug === parentSlug);
					if (parent) {
						if (parent.tags) parent.tags.push(t);
						else parent.tags = [t];
					}
				}
			})
		} else {
			if (group) {
				tags.forEach(t => {
					const existingTag = group.tags.find(e => e.slug === t.slug)
					if (existingTag && existingTag.variable && t.variable) {
						existingTag.variable = Math.max(existingTag.variable, t.variable);
					} else if (!existingTag) {
						if (t.slug === "wizard" && group.tags.find(e => e.slug === "priest")) return;
						group.tags.push(t);
					}
				})
			} else {
				const newGroup = { ...tagGroup };
				newGroup.tags = JSON.parse(JSON.stringify(tags));
				if (listEntry) {
					if (listEntry.profiles) {
						listEntry.profiles.forEach(p => {
							p.tagGroups ||= [];
							p.tagGroups.push(newGroup);
						});
					} else {
						listEntry.tagGroups ||= [];
						listEntry.tagGroups.push(newGroup);
					}
				} else {
					node.tagGroups = [newGroup];
				}
			}
		}
	},
	"REMOVE_TAGS": (node, params, source, list) => {
		const { listEntry } = node;
		const { tagGroup, tags = [], profileName } = params;

		if (!tagGroup || tags.length <= 0) return;

		if (!listEntry.profiles && profileName) return;

		let profileIndex = null;
		if (listEntry.profiles) {
			if (profileName) {
				profileIndex = listEntry.profiles.findIndex(p => p.profileName === profileName);
				if (profileIndex < 0) {
					return;
				}
			} else {
				profileIndex = 0;
			}
		}

		const tagGroups = listEntry?.tagGroups || listEntry?.profiles?.[profileIndex]?.tagGroups || node.tagGroups;

		const group = tagGroups?.find(g => g.slug === tagGroup.slug);
		if (group) {
			group.tags = group.tags?.filter(t => !tags.includes(t.slug));
		}
	},
	"REPLACE_TAGS": (node, params) => {
		const { listEntry } = node;
		const { tagGroup, tags = [] } = params;

		if (!tagGroup || tags.length <= 0) return;

		// findGroup
		// if not, create it and push tags
		// if exists, look for tags

		const group = listEntry ? listEntry.tagGroups?.find(g => g.slug === tagGroup.slug) : node.tagGroups?.find(g => g.slug === tagGroup.slug);
		if (group) {
			group.tags = tags;
		} else {
			const newGroup = { ...tagGroup };
			newGroup.tags = tags;
			if (listEntry) {
				listEntry.tagGroups ||= [];
				listEntry.tagGroups.push(newGroup);
			} else {
				// TODO: tagGroups on the node needs reworking. This implementation
				// does not take into account potentially existing tags.
				node.tagGroups = [newGroup];
			}
		}
	},
	"REMOVE_TAGGROUPS": (node, params) => {
		const { listEntry } = node;
		const { slugs = [] } = params;

		listEntry.tagGroups ||= [];
		listEntry.tagGroups = listEntry.tagGroups.filter(g => !slugs.includes(g.slug));
	},
	"MODIFY_TAG": (node, params) => {
		const { tagGroups = [] } = node.listEntry;
		const { slug, variable, range, tags, query, parentSlug } = params;

		const tag = getTag(tagGroups, slug, parentSlug);
		if (tag) {
			if (variable) {
				tag.variable = operate(tag.variable, variable);
			}
			if (range) {
				tag.range = operate(tag.range, range);
			}
			if (tags) {
				tag.tags ||= [];
				tag.tags.push(...tags);
			}
			if (query) {
				tag.query = query;
			}
		}
	},
	"MODIFY_TYPE": (node, params) => {
		const { listEntry } = node;
		const { newType, newClass } = params;

		if (newType) listEntry.type = newType;
		if (newClass) listEntry.gameClass = newClass;
	},
	"MODIFY_STAT": (node, params) => {
		const { listEntry } = node;
		const { key, operation, variable, min, max } = params;

		function limit(a) {
			if (a < min) return min;
			if (a > max) return max;
			return a;
		}

		const statlines = [];
		if (listEntry.profiles) {
			listEntry.profiles.forEach(profile => {
				statlines.push(profile.statline);
			});
		} else {
			statlines.push(listEntry.statline);
		}

		statlines.forEach(statline => {
			if (isNaN(statline[key])) statline[key] = 0;

			if (operation === "add") {
				statline[key] = limit(statline[key] + variable);
			} else if (operation === "subtract") {
				statline[key] = limit(statline[key] - variable);
			} else if (operation === "multiply") {
				statline[key] = limit(statline[key] * variable);
			} else if (operation === "divide") {
				statline[key] = limit(statline[key] / variable);
			}
		});
	},
	"SET_STATS": (node, params) => {
		const { listEntry } = node;

		for (const stat in params) {
			listEntry.statline[stat] = params[stat];
		}
	},
	"MASTERIES_AFTER": (node, params, source, list) => {
		const { listEntry } = node;
		const times = countSlug(list, source.slug)
		const options = getOptions(listEntry.options, [source.slug]);
		options.forEach(o => {
			if (!o.selected && !o.masterized) {
				o.masterized = true;
				o.cost *= Math.pow(2, times);
			}
		});
	},
	"MASTERIES_PRE": (node, params, source, list) => {
		const { listEntry } = node;
		const times = countSlug(list, source.slug) - 1;
		const options = getOptions(listEntry.options, [source.slug]);
		options.forEach(o => {
			if (o.selected && !o.masterized) {
				o.masterized = true;
				o.cost *= Math.pow(2, times);
			}
		});
	},
	"ECCENTRIC": (node, params, source, list, faction) => {
		const { listEntry } = node;
		const { entrySlugs } =
			faction.entryGroups.find(g => g.slug === "regiments");

		listEntry.warband.restricted = entrySlugs.map(s => faction.entries[s]);
	},
	"KNIGHTLY_ENTOURAGE": (node) => {
		const { listEntry } = node;
		listEntry.warband.mainstay.push({ name: "Mounted Squires", slug: "mounted-squires" });
	},
	"DYNAMIC_SEASONS": (node, params, source, list) => {
		const courts = [];
		const {children: warbands} = list;
		const characters = warbands.reduce((prev, cur) => [...prev, ...cur.children.filter(c => c.type === "character")], []);
		characters.forEach(c => {
			if (c.listEntry.isWarlord) {
				const tags = c.listEntry.tagGroups?.find(g => g.slug === "battlefield-role")?.tags?.map(t => t.slug) || [];
				if (tags.includes("court-of-winter")) {
					courts.push({name: "Court of Winter", slug: "court-of-winter"});
				}
				if (tags.includes("court-of-spring")) {
					courts.push({name: "Court of Spring", slug: "court-of-spring"});
				}
				if (tags.includes("court-of-summer")) {
					courts.push({name: "Court of Summer", slug: "court-of-summer"});
				}
				if (tags.includes("court-of-autumn")) {
					courts.push({name: "Court of Autumn", slug: "court-of-autumn"});
				}
			}
		});

		if (courts.length > 0) {
			node.listEntry.tagGroups.push({
				name: "Battlefield Role",
				slug: "battlefield-role",
				tags: [...courts]
			});
		}
	},
	"ARDENT_CREED": (node, params, source, list) => {
		if (node.listEntry.isWarlord) {
			list.tagGroups = [
				{
					name: "Army Rules",
					slug: "army-rules",
					tags: [
						{
							name: "The Ardent Creed",
							slug: "the-ardent-creed",
							query: {
								label: "The Ardent Creed",
								request: {
									type: "directives",
									slug: "the-ardent-creed"
								}
							}
						}
					]
				}
			]
		}
	},
	"TEMPERED_CREED": (node, params, source, list) => {
		if (node.listEntry.isWarlord) {
			list.tagGroups = [
				{
					name: "Army Rules",
					slug: "army-rules",
					tags: [
						{
							name: "The Tempered Creed",
							slug: "the-tempered-creed",
							query: {
								label: "The Tempered Creed",
								request: {
									type: "directives",
									slug: "the-tempered-creed"
								}
							}
						}
					]
				}
			]

			list.children.forEach(w => {
				const slugs = ["tempered-steelshaper", "tempered-sorcerer"];
				const targets = w.children.filter(c => c.type === "character" && slugs.includes(c.listEntry.slug));
				targets.forEach(t => {
					const group = t.listEntry.tagGroups.find(g => g.slug === "special-rules")
					group.tags.push({
						name: "Elemental Potency",
						slug: "elemental-potency",
						query: {
							label: "Elemental Potency",
							request: {
								type: "directives",
								slug: "elemental-potency"
							}
						}
					})
				})
			})
		}
	},
	"HOLY_CRUSADE": (node, params, source, list, faction) => {
		if (node.listEntry.isWarlord || node.selections.includes("dynastic-ally")) {
			const cb = node.listEntry.options.groups.find(g => g.slug === "crusading-bulls");
			if (cb) cb.maxOptions = 9999;

			const w = node.parent;
			const crusaders = w.children.find(c => c.entrySlug === "crusaders");
			if (crusaders) crusaders.listEntry.cost = 0;
		}
	},
	"THE_SPIRIT_SHINES": (node, params, source, list, faction) => {
		if (source.listEntry.isWarlord || source.selections.includes("dynastic-ally")) {
			const sr = node.listEntry.tagGroups.find(g => g.slug === "special-rules");
			if (sr) {
				sr.tags.push(
					{
						name: "Divine Purpose",
						slug: "divine-purpose",
						query: {
							label: "Divine Purpose",
							request: {
								type: "directives",
								slug: "divine-purpose"
							}
						}
					}
				);
			} else {
				node.listEntry.tagGroups.unshift({
					name: "Special Rules",
					slug: "special-rules",
					tags: [
						{
							name: "Divine Purpose",
							slug: "divine-purpose",
							query: {
								label: "Divine Purpose",
								request: {
									type: "directives",
									slug: "divine-purpose"
								}
							}
						}
					]
				});
			}
		}
	},
	"PROFESSIONAL_TROOPS": (node, params, source, list, faction) => {
		if (source.listEntry.isWarlord || source.selections.includes("dynastic-ally")) {
			const sr = node.listEntry.tagGroups.find(g => g.slug === "special-rules");
			if (sr) {
				sr.tags.push(
					{
						name: "Veteran",
						slug: "veteran",
						query: {
							label: "Veteran",
							request: {
								type: "directives",
								slug: "veteran"
							}
						}
					}
				);
			} else {
				node.listEntry.tagGroups.unshift({
					name: "Special Rules",
					slug: "special-rules",
					tags: [
						{
							name: "Veteran",
							slug: "veteran",
							query: {
								label: "Veteran",
								request: {
									type: "directives",
									slug: "veteran"
								}
							}
						}
					]
				});
			}

			const veteran = node.listEntry.options?.orphans?.find(o => o.slug === "veteran");
			if (veteran) veteran.active = false;

			// Second part of ability

			const roleTags = [
				{
					name: "Theist",
					slug: "theist"
				},
				{
					name: "Imperial",
					slug: "imperial"
				},
				{
					name: "Feudal",
					slug: "feudal"
				},
				{
					name: "The Orders",
					slug: "the-orders"
				}
			];

			const br = node.listEntry.tagGroups.find(g => g.slug === "battlefield-role");
			const rolesExisting = br.tags.map(t => t.slug);

			list.children.forEach(w => {
				const character = w.children.find(e => e.type === "character");
				if (character.listEntry.isWarlord || character.selections.includes("dynastic-ally")) {
					roleTags.forEach(t => {
						if (hasTags(character.listEntry, [t.slug]) && !rolesExisting.includes(t.slug)) br.tags.push(t);
					});
				}
			})

		}
	},
	"PROFESSIONAL_CHARACTERS": (node, params, source, list, faction) => {
		if (source.listEntry.isWarlord || source.selections.includes("dynastic-ally")) {
			const roleTags = [
				{
					name: "Theist",
					slug: "theist"
				},
				{
					name: "Imperial",
					slug: "imperial"
				},
				{
					name: "Feudal",
					slug: "feudal"
				},
				{
					name: "The Orders",
					slug: "the-orders"
				}
			];

			const rolesExisting = node.listEntry.tagGroups.find(g => g.slug === "battlefield-role").tags;

			list.children.forEach(w => {
				const character = w.children.find(e => e.type === "character");
				if (character.id === source.id) return;
				if (character.listEntry.isWarlord || character.selections.includes("dynastic-ally")) {
					roleTags.forEach(t => {
						if (hasTags(character.listEntry, [t.slug]) && !hasTags(node.listEntry, [t.slug])) rolesExisting.push(t);
					});
				}
			})
		}
	},
	"WARLORD": (node, params, source, list, faction) => {
		// TODO: Names should never be used in rules, effects, etc. only slugs.
		// There should be a way to derive the name from the faction data.
		// With tags this seems easy because they already have unique slugs, so
		// pull them out in a tags object just like entries and then only use slugs
		// in the entry data.
		if (node.listEntry.isWarlord) {
			const { tagGroups = [] } = node.listEntry;
			if (faction.slug === "the-hundred-kingdoms") {
				const { children: warbands } = list;
				warbands.forEach(w => {
					const character = w.children.find(c => c.type === "character" && c.entrySlug !== node.entrySlug);
					if (character) {
						const ally = character.listEntry.options?.orphans?.find(o => o.slug === "dynastic-ally");
						if (ally) ally.active = true;
					}
				});
			} else if (node.listEntry.slug === "biomancer") {
				node.listEntry.texts ||= [];
				node.listEntry.texts.push(
					{
						"content": "Your Warlord may perform a free additional Practitioner Action each Activation. You cannot perform the same Biomancy more than once during a single Activation.",
						"tag": ""
					}
				);
			} else if (node.listEntry.slug === "scion-of-conquest") {
				const drumBeasts = node.parent.children.filter(c => c.entrySlug === "drum-beast");
				if(drumBeasts[0]) drumBeasts[0].type = "mainstay";
			} else if (node.listEntry.slug === "pheromancer") {
				node.listEntry.texts ||= [];
				node.listEntry.texts.push(
					{
						"content": "Your Warlord may perform a free additional Practitioner Action each Activation. You cannot perform the same Pheromancy more than once during a single Activation.",
						"tag": ""
					}
				);
			} else if (node.listEntry.slug === "lineage-prideborne") {
				const { children: warbands } = list;
				const husks = [];
				warbands.forEach(w => {
					husks.push(...w.children.filter(c => c.type !== "character" && hasTags(c.listEntry, ["husk"])));
				});

				husks.forEach(b => {
					const sr = b.listEntry.tagGroups.find(g => g.slug === "special-rules");
					if (sr) {
						sr.tags.push(
							{
								name: "Designate Target",
								slug: "designate-target",
								query: {
									label: "Designate Target",
									request: {
										type: "directives",
										slug: "designate-target"
									}
								}
							}
						);
					} else {
						b.listEntry.tagGroups.unshift({
							name: "Special Rules",
							slug: "special-rules",
							tags: [
								{
									name: "Designate Target",
									slug: "designate-target",
									query: {
										label: "Designate Target",
										request: {
											type: "directives",
											slug: "designate-target"
										}
									}
								}
							]
						});
					}
				});
			} else if (node.listEntry.slug === "chieftain") {
				const { children: warbands } = list;
				const tribes = [];
				warbands.forEach(w => {
					if (w.children.find(c => c.type === "character")?.id === node.id) return;
					tribes.push(...w.children.filter(c => c.type !== "character" && getTag(c.listEntry.tagGroups, "the-tribes")));
				});

				tribes.forEach(b => {
					const sr = b.listEntry.tagGroups.find(g => g.slug === "special-rules");
					if (sr) {
						sr.tags.push(
							{
								name: "Vanguard",
								slug: "vanguard",
								variable: 3,
								query: {
									label: "Vanguard X",
									request: {
										type: "directives",
										slug: "vanguard"
									}
								}
							}
						);
					} else {
						b.listEntry.tagGroups.unshift({
							name: "Special Rules",
							slug: "special-rules",
							tags: [
								{
									name: "Vanguard",
									slug: "vanguard",
									variable: 3,
									query: {
										label: "Vanguard X",
										request: {
											type: "directives",
											slug: "vanguard"
										}
									}
								}
							]
						});
					}
				});
			} else if (node.listEntry.slug === "hold-raegh" || node.listEntry.slug === "exemplar") {
				const sr = node.listEntry.tagGroups.find(g => g.slug === "special-rules");
				sr.tags.push(
					{
						name: "Forward Force",
						slug: "forward-force",
						query: {
							label: "Forward Force",
							request: {
								type: "directives",
								slug: "forward-force"
							}
						}
					}
				);
			} else if (node.listEntry.slug === "lost-ancestor") {
				const arOptions = list.options.groups.find(g => g.slug === "army-rules");
				arOptions.active = false;

				list.tagGroups = [
					{
						name: "Army Rules",
						slug: "army-rules",
						tags: [
							{
								name: "The Tempered Creed",
								slug: "the-tempered-creed",
								query: {
									label: "The Tempered Creed",
									request: {
										type: "directives",
										slug: "the-tempered-creed"
									}
								}
							},
							{
								name: "The Ardent Creed",
								slug: "the-ardent-creed",
								query: {
									label: "The Ardent Creed",
									request: {
										type: "directives",
										slug: "the-ardent-creed"
									}
								}
							}
						]
					}
				];
			} else if (node.listEntry.slug === "seanchas-sidhe") {
				node.listEntry.tagGroups.push({
					name: "Spells",
					slug: "spells",
					tags: [
						{
							name: "Court of Summer",
							slug: "court-of-summer",
							query: {
								label: "Court of Summer",
								request: {
									type: "directives",
									slug: "court-of-summer"
								}
							}
						},
						{
							name: "Court of Winter",
							slug: "court-of-winter",
							query: {
								label: "Court of Winter",
								request: {
									type: "directives",
									slug: "court-of-winter"
								}
							}
						}
					]
				});
			}
		}
	},
	"BLASPHEMOUS_MESA": (node, params, source, list) => {
		if (!node.listEntry.isWarlord) return;

		const { listEntry } = node;
		listEntry.tagGroups.push({
			name: "Draw Events",
			slug: "draw-events",
			tags: [
				{
					name: "Blasphemous Mesa",
					slug: "blasphemous-mesa",
					query: {
						label: "Blasphemous Mesa",
						request: {
							type: "directives",
							slug: "blasphemous-mesa-de"
						}
					}
				}
			]
		});

		list.children.forEach(w => {
			w.children.filter(c => c.type != "character").forEach(r => {
				const { tagGroups = [] } = r.listEntry;
				const t = getTag(tagGroups, "aura-of-death");

				if (t) {
					t.variable += 1;
				} else {
					const sr = r.listEntry.tagGroups.find(g => g.slug === "special-rules");
					if (sr) {
						sr.tags.push({
							name: "Aura of Death",
							slug: "aura-of-death",
							variable: 1,
							query: {
								label: "Aura of Death (X)",
								request: {
									type: "directives",
									slug: "aura-of-death"
								}
							}
						});
					} else {
						r.listEntry.tagGroups.unshift({
							name: "Special Rules",
							slug: "special-rules",
							tags: [
								{
									name: "Aura of Death",
									slug: "aura-of-death",
									variable: 1,
									query: {
										label: "Aura of Death (X)",
										request: {
											type: "directives",
											slug: "aura-of-death"
										}
									}
								}
							]
						});
					}
				}
			});
		});
	},
	"OPTIMIZED_FODDER": (node, params, source, list) => {
		const { listEntry } = node;
		if (listEntry.size >= 6) {
			const de = listEntry.tagGroups.find(g => g.slug === "draw-events");
			const regeneration = de.tags.find(t => t.slug === "regeneration");
			regeneration.variable = "+4";

			const strain = listEntry.tagGroups.find(g => g.slug === "strain");
			const spasms = strain.tags.find(t => t.slug === "apoptotic-spasms");
			spasms.query.request.slug = "apoptotic-spasms-alt"
		}
	},
	"HELLBRINGER_SORCERER": (node, params, source, list) => {
		const { listEntry, linkedNodes } = node;
		const selector = listEntry.entrySelectors.find(s => s.slug === "hellbringer-sorcerer-mount");
		if (selector) {
			const drakes = node.parent.children.filter(c => c.listEntry.slug === "hellbringer-drake");
			selector.targets = drakes;
			selector.active = true;

			// if (linkedNodes["hellbringer-sorcerer-mount"]) {
			// 	const path = linkedNodes["hellbringer-sorcerer-mount"][0];
			// 	const target = getNode(list, path);
			// 	if (target) {
			// 		const special = target.listEntry.tagGroups.find(g => g.slug === "special-rules");
			// 		special.tags.push({
			// 			name: "You and What Army?",
			// 			slug: "you-and-what-army",
			// 			query: {
			// 				label: "You and What Army?",
			// 				request: {
			// 					type: "directives",
			// 					slug: "you-and-what-army"
			// 				}
			// 			}
			// 		});
			// 	}
			// }
		}
	},
	"DRAIC_RIDER": (node, params, source, list) => {
		const { listEntry, linkedNodes } = node;
		const selector = listEntry.entrySelectors.find(s => s.slug === "draic-rider-mount");
		if (selector) {
			const draics = node.parent.children.filter(c => ["coill-draic", "scoth-draic"].includes(c.listEntry.slug));
			selector.targets = draics;
			selector.active = true;

			if (linkedNodes["draic-rider-mount"]) {
				const path = linkedNodes["draic-rider-mount"][0];
				const target = getNode(list, path);
				if (target) {
					const sr = target.listEntry.tagGroups.find(g => g.slug === "special-rules");
					sr.tags.push({
						name: "Flank",
						slug: "flank",
						query: {
							label: "Flank",
							request: {
								type: "directives",
								slug: "flank"
							}
						}
					});
				}
			}
		}
	},
	"BERGONT_RAEGH": (node, params, source, list) => {
		const { listEntry, linkedNodes } = node;
		const selector = listEntry.entrySelectors.find(s => s.slug === "infernal-rider-mount");
		if (selector) {
			const drakes = node.parent.children.filter(c => c.listEntry.slug === "ironclad-drake");
			selector.targets = drakes;
			selector.active = true;

			// if (linkedNodes["infernal-rider-mount"]) {
			// 	const path = linkedNodes["infernal-rider-mount"][0];
			// 	const target = getNode(list, path);
			// 	if (target) {
			// 		const special = target.listEntry.tagGroups.find(g => g.slug === "special-rules");
			// 		special.tags.push({
			// 			name: "You and What Army?",
			// 			slug: "you-and-what-army",
			// 			query: {
			// 				label: "You and What Army?",
			// 				request: {
			// 					type: "directives",
			// 					slug: "you-and-what-army"
			// 				}
			// 			}
			// 		});
			// 	}
			// }
		}
		if (!listEntry.isWarlord) {
			node.alerts.push({ message: "A Bergont Raegh must be selected as Warlord." });
		}
	},
	"THUNDEROUS_ASSAULT": (node, params, source, list) => {
		const { listEntry } = node;
		if (listEntry.isWarlord) {
			const { children: warbands } = list;
			const regiments = [];

			warbands.forEach(w => {
				regiments.push(...w.children.filter(c => (c.type !== "character" && getTag(c.listEntry?.tagGroups || [], "the-speakers")) || c.entrySlug === "winglord-predator"));
			});

			regiments.forEach(r => {
				r.listEntry.tagGroups ||= [];
				const sr = r.listEntry.tagGroups.find(g => g.slug === "special-rules");
				if (sr) {
					const shock = sr?.tags?.find(t => t.slug === "shock");
					if (!shock) {
						sr.tags.push({
							name: "Shock",
							slug: "shock",
							query: {
								label: "Shock",
								request: {
									type: "directives",
									slug: "shock"
								}
							}
						})
					}
				} else {
					r.listEntry.tagGroups.push({
						name: "Special Rules",
						slug: "special-rules",
						tags: [
							{
								name: "Shock",
								slug: "shock",
								query: {
									label: "Shock",
									request: {
										type: "directives",
										slug: "shock"
									}
								}
							}
						]
					})
				}
			})
		}
	},
	"APEX_MASTER": (node, params, source, list) => {
		const { listEntry, linkedNodes } = node;
		const selector = listEntry.entrySelectors.find(s => s.slug === "apex-master-mount");
		if (selector) {
			const predators = node.parent.children.filter(c => c.listEntry.slug === "apex-predator");
			selector.targets = predators;
			selector.active = true;

			if (linkedNodes["apex-master-mount"]) {
				const path = linkedNodes["apex-master-mount"][0];
				const target = getNode(list, path);
				if (target) {
					// target.listEntry.tagGroups.push({
					// 	name: "Draw Events",
					// 	slug: "draw-event",
					// 	tags: [
					// 		{
					// 			name: "Bastion",
					// 			slug: "bastion",
					// 			variable: 1,
					// 			query: {
					// 				label: "Bastion X",
					// 				request: {
					// 					type: "directives",
					// 					slug: "bastion"
					// 				}
					// 			}
					// 		}
					// 	]
					// });

					// const special = target.listEntry.tagGroups.find(g => g.slug === "special-rules");
					// special.tags.push({
					// 	name: "You and What Army?",
					// 	slug: "you-and-what-army",
					// 	query: {
					// 		label: "You and What Army?",
					// 		request: {
					// 			type: "directives",
					// 			slug: "you-and-what-army"
					// 		}
					// 	}
					// });
				}
			}
		}
	},
	"LORD_OF_ALL_THEY_SEE": (node, params, source, list) => {
		const { listEntry, linkedNodes } = node;
		const selector = listEntry.entrySelectors.find(s => s.slug === "lord-of-all-they-see-mount");
		if (selector) {
			const mahuts = node.parent.children.filter(c => c.listEntry.slug === "mahut");
			selector.targets = mahuts;
			selector.active = true;
		}
	},
	"FERRIC_THRONE": (node, params, source, list) => {
		const { listEntry, linkedNodes } = node;
		const selector = listEntry.entrySelectors.find(s => s.slug === "ferric-throne-mount");
		if (selector) {
			const stoneforged = node.parent.children.filter(c => c.listEntry.slug === "stoneforged");
			selector.targets = stoneforged;
			selector.active = true;
		}
	},
	"SARDAR_COURT": (node, params, source, list) => {
		const warlordCourts = [];
		const warbands = list.children;
		warbands.forEach(w => {
			const character = w.children.find(c => c.type === "character");
			if (character && character.listEntry.isWarlord) {
				const roles = character.listEntry.tagGroups.find(g => g.slug === "battlefield-role")?.tags || [];
				roles.forEach(r => {
					if (r.slug.startsWith("court-of") && !warlordCourts.find(c => c.slug === r.slug)) {
						warlordCourts.push(r);
					}
				});
			}
		});

		const br = node.listEntry.tagGroups.find(g => g.slug === "battlefield-role");
		br.tags.push(...warlordCourts);

		node.parent.children.filter(c => ["rajakur", "dhanurveda-archers", "mahabharati-initiates"].includes(c.entrySlug)).forEach(c => {
			const br = c.listEntry.tagGroups.find(g => g.slug === "battlefield-role");
			br.tags.push(...warlordCourts);
		});
	},
	"DYNAMIC_COURTS": (node, params, source, list) => {
		const warlordCourts = [];
		const warbands = list.children;
		warbands.forEach(w => {
			const character = w.children.find(c => c.type === "character");
			if (character && character.listEntry.isWarlord) {
				const roles = character.listEntry.tagGroups.find(g => g.slug === "battlefield-role")?.tags || [];
				roles.forEach(r => {
					if (r.slug.startsWith("court-of") && !warlordCourts.includes(r.slug)) {
						warlordCourts.push(r.slug);
					}
				});
			}
		});

		if (warlordCourts.length > 0) {
			const cg = node.listEntry.options.groups.find(g => g.slug === "courts");
			if (cg) {
				cg.active = true;
				cg.orphans.forEach(o => {
					if (warlordCourts.includes(o.slug)) o.active = true;
				});
			}
		}
	},
	"WARLORD_COPY_COURTS": (node, params, source, list) => {
		const warlordCourts = [];
		const warbands = list.children;
		warbands.forEach(w => {
			const character = w.children.find(c => c.type === "character");
			if (character && character.listEntry.isWarlord) {
				const roles = character.listEntry.tagGroups.find(g => g.slug === "battlefield-role")?.tags || [];
				roles.forEach(r => {
					if (r.slug.startsWith("court-of") && !warlordCourts.find(c => c.slug === r.slug)) {
						warlordCourts.push(r);
					}
				});
			}
		});

		if (warlordCourts.length > 0) {
			const rg = node.listEntry.tagGroups.find(g => g.slug === "battlefield-role");
			if (rg) {
				rg.tags = rg.tags.filter(t => !t.slug.startsWith("court-of"));
				rg.tags.push(...warlordCourts);
			}
		}
	},
	"TONTORR_RIDER": (node, params, source, list) => {
		const { listEntry } = node;
		const selector = listEntry.entrySelectors.find(s => s.slug === "tontorr-rider-mount");
		if (selector) {
			const tontorrs = node.parent.children.filter(c => c.listEntry.slug === "tontorr");
			selector.targets = tontorrs;
			selector.active = true;
		}
	},
	"DRUM_BEAST_RIDER": (node, params, source, list) => {
		const { listEntry } = node;
		const selector = listEntry.entrySelectors.find(s => s.slug === "drum-beast-rider-mount");
		if (selector) {
			const beasts = node.parent.children.filter(c => c.listEntry.slug === "drum-beast");
			selector.targets = beasts;
			selector.active = true;
		}
	},
	"SANCTIFIED_LABARON": (node, params, source, list) => {
		const { listEntry, linkedNodes } = node;
		const selector = listEntry.entrySelectors.find(s => s.slug === "sanctified-labaron");
		if (selector) {
			const restricted = node.parent.children.filter(c => c.type === "restricted");
			selector.targets = restricted;
			selector.active = true;

			if (linkedNodes["sanctified-labaron"]) {
				const path = linkedNodes["sanctified-labaron"][0];
				const target = getNode(list, path);
				if (target) {
					target.type = "mainstay"
				}
			}
		}
	},
	"ENABLE_PROFILE": (node, params) => {
		const { listEntry } = node;
		const profile = listEntry.profiles?.find(p => p.profileName === params.profileName);
		if (profile) profile.active = params.enabled;
	},
	"GODFLESH": (node, params, source, list) => {
		const { listEntry } = node;
		if (listEntry.isWarlord) {
			const { children: warbands } = list;
			const regiments = [];

			warbands.forEach(w => {
				regiments.push(...w.children.filter(c => c.entrySlug === "clockwork-hoplites"));
			});

			regiments.forEach(r => r.listEntry.gameClass = "Medium");
		}
	},
	"MODIFY_WARBAND": (node, params) => {
		const { listEntry } = node;
		const { entries, type } = params;
		listEntry.warband.restricted = listEntry.warband.restricted.filter(e => !entries.some(s => e.slug === s.slug));
		listEntry.warband.mainstay = listEntry.warband.mainstay.filter(e => !entries.some(s => e.slug === s.slug));

		if (type === "mainstay") {
			listEntry.warband.mainstay.push(...entries);
		} else if (type === "restricted") {
			listEntry.warband.restricted.push(...entries);
		}

		const entrySlugs = entries.map(e => e.slug);
		const attached = node.parent.children.filter(c => entrySlugs.includes(c.entrySlug))
		attached.forEach(a => a.type = type);
	},
	"SORCEROUS_PATRONAGE": (node, params) => {
		const { listEntry } = node;

		const fireEntries = [
			{
				name: "Efreet Flamecasters",
				slug: "efreet-flamecasters",
			},
			{
				name: "Efreet Sword Dancers",
				slug: "efreet-sword-dancers",
			},
		];
		const airEntries = [
			{
				name: "Steelheart Djinn",
				slug: "steelheart-djinn",
			},
			{
				name: "Windborne Djinn",
				slug: "windborne-djinn",
			},
		];
		const waterEntries = [
			{
				name: "Marid Sahar",
				slug: "marid-sahar",
			},
			{
				name: "Marid Lancers",
				slug: "marid-lancers",
			},
		];
		const earthEntries = [
			{
				name: "Eternal Destroyers",
				slug: "eternal-destroyers",
			},
			{
				name: "Eternal Ikons",
				slug: "eternal-ikons",
			},
		];

		const group = listEntry.tagGroups.find(g => g.slug === "battlefield-role");
		if (group) {
			const courts = group.tags.filter(t => t.slug.startsWith("court-of")).map(t => t.slug);
			if (courts.includes("court-of-fire")) {
				listEntry.warband.mainstay = listEntry.warband.mainstay.filter(e => !fireEntries.some(s => e.slug === s.slug));
				listEntry.warband.mainstay.push(...fireEntries);
				const entrySlugs = fireEntries.map(e => e.slug);
				const attached = node.parent.children.filter(c => entrySlugs.includes(c.entrySlug))
				attached.forEach(a => a.type = "mainstay");
			} else {
				const entrySlugs = fireEntries.map(e => e.slug);
				const attached = node.parent.children.filter(c => entrySlugs.includes(c.entrySlug))
				attached.forEach(a => a.type = "restricted");
			}
			if (courts.includes("court-of-air")) {
				listEntry.warband.mainstay = listEntry.warband.mainstay.filter(e => !airEntries.some(s => e.slug === s.slug));
				listEntry.warband.mainstay.push(...airEntries);
				const entrySlugs = airEntries.map(e => e.slug);
				const attached = node.parent.children.filter(c => entrySlugs.includes(c.entrySlug))
				attached.forEach(a => a.type = "mainstay");
			} else {
				const entrySlugs = airEntries.map(e => e.slug);
				const attached = node.parent.children.filter(c => entrySlugs.includes(c.entrySlug))
				attached.forEach(a => a.type = "restricted");
			}
			if (courts.includes("court-of-water")) {
				listEntry.warband.mainstay = listEntry.warband.mainstay.filter(e => !waterEntries.some(s => e.slug === s.slug));
				listEntry.warband.mainstay.push(...waterEntries);
				const entrySlugs = waterEntries.map(e => e.slug);
				const attached = node.parent.children.filter(c => entrySlugs.includes(c.entrySlug))
				attached.forEach(a => a.type = "mainstay");
			} else {
				const entrySlugs = waterEntries.map(e => e.slug);
				const attached = node.parent.children.filter(c => entrySlugs.includes(c.entrySlug))
				attached.forEach(a => a.type = "restricted");
			}
			if (courts.includes("court-of-earth")) {
				listEntry.warband.mainstay = listEntry.warband.mainstay.filter(e => !earthEntries.some(s => e.slug === s.slug));
				listEntry.warband.mainstay.push(...earthEntries);
				const entrySlugs = earthEntries.map(e => e.slug);
				const attached = node.parent.children.filter(c => entrySlugs.includes(c.entrySlug))
				attached.forEach(a => a.type = "mainstay");
			} else {
				const entrySlugs = earthEntries.map(e => e.slug);
				const attached = node.parent.children.filter(c => entrySlugs.includes(c.entrySlug))
				attached.forEach(a => a.type = "restricted");
			}
		}
	},
	"ADD_TEXT": (node, params) => {
		const { listEntry } = node;

		listEntry.texts ??= [];

		listEntry.texts.push({
			tag: "",
			content: params.text,
		})
	},
	"ADVANCED_INFANTRY": (node, params) => {
		const roles = node.listEntry.tagGroups?.find(g => g.slug === "battlefield-role")?.tags?.map(t => t.slug) || [];
		if (roles.includes("veteran")) {
			const sr = node.listEntry.tagGroups.find(g => g.slug === "special-rules");
			if (sr) {
				const support = sr?.tags?.find(t => t.slug === "support");
				if (!support) {
					sr.tags.push({
						name: "Support",
						slug: "support",
						query: {
							label: "Support X",
							request: {
								type: "directives",
								slug: "support"
							}
						},
						variable: 2
					})
				} else {
					support.variable += 1;
				}
			} else {
				node.listEntry.tagGroups.push({
					name: "Special Rules",
					slug: "special-rules",
					tags: [
						{
							name: "Support",
							slug: "support",
							query: {
								label: "Support X",
								request: {
									type: "directives",
									slug: "support"
								}
							},
							variable: 2
						}
					]
				})
			}
		}
	},
	"ADVANCED_CAVALRY": (node, params) => {
		const roles = node.listEntry.tagGroups?.find(g => g.slug === "battlefield-role")?.tags?.map(t => t.slug) || [];
		if (roles.includes("veteran")) {
			node.listEntry.statline["C"] += 1;
		}
	},
}

function countSlug(node, slug) {
	let local = node.selections.filter(e => e === slug).length;
	node.children.forEach(c => {
		local += countSlug(c, slug);
	})
	return local;
}


export default TLAOK_EFFECTS